import { ChatConversation, Identifiable } from "@planzone/dto";
import { HttpClient, HttpMethods } from "@planzone/services";

function getChatConversations(httpClient: HttpClient) {
  return () =>
    httpClient
      .sendHttpRequest<
        { id: string; title: string; createdAt: string; updatedAt: string }[]
      >({
        endpoint: `/secured/conversations`,
        method: HttpMethods.GET,
      })
      .then((conversations) =>
        conversations.map(
          ({ id, ...conversation }): Identifiable<ChatConversation> => ({
            ...conversation,
            uuid: id,
          }),
        ),
      );
}

export { getChatConversations };
